import { DiscountUnits } from '../../../utils/constants';
import _ from 'lodash';

export function createManagerDiscount(currentDiscount, newDiscount) {
  const unit = newDiscount.unit || currentDiscount.unit;
  let currencyAmount = currentDiscount.currencyAmount;
  let percentAmount = currentDiscount.percentAmount;
  let amount;

  if (unit === DiscountUnits.CURRENCY && _.isNumber(newDiscount.amount)) {
    currencyAmount = newDiscount.amount;
    amount = newDiscount.amount;
  } else if (unit === DiscountUnits.PERCENT && _.isNumber(newDiscount.amount)) {
    percentAmount = newDiscount.amount;
    amount = newDiscount.amount;
  }

  if (!_.isNumber(newDiscount.amount)) {
    amount = unit === DiscountUnits.CURRENCY ? currencyAmount : percentAmount;
  }

  return {
    unit,
    amount,
    currencyAmount,
    percentAmount,
  };
}
